import UnenrollmentSettingsSection from 'automation-ui-canvas/containers/settings/v2/UnenrollmentSettingsSection';
import { getClassicEnrollmentSettings, getGoalFilters, getSuppressionFilters, getSuppressionLists } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import useSettingsModelState from 'automation-ui-canvas/containers/settings/v2/useSettingsModelState';
import UIButton from 'UIComponents/button/UIButton';
import { useHistory } from 'react-router-dom';
import { getEnrollmentConfigRoute } from 'automation-ui-canvas/utils/absoluteRoutingUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getEnrollmentList } from 'automation-ui-enrollment/utils/listFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnenrollmentReviewSection = ({
  flow
}) => {
  const history = useHistory();
  const classicEnrollmentSettings = useSettingsModelState({
    flow,
    initialize: initialFlow => {
      return getClassicEnrollmentSettings(initialFlow);
    },
    useStaged: false
  });
  const suppressionFilters = useSettingsModelState({
    flow,
    initialize: initialFlow => {
      if (initialFlow.isClassicWorkflow) {
        return {
          value: null
        };
      }
      return {
        value: getSuppressionFilters(initialFlow)
      };
    },
    useStaged: false
  });
  /* classic suppression lists */
  const suppressionLists = useSettingsModelState({
    flow,
    initialize: initialFlow => {
      return {
        value: getSuppressionLists(initialFlow)
      };
    },
    useStaged: false
  });
  const goalFilters = useSettingsModelState({
    flow,
    initialize: initialFlow => {
      /* initialize to null for platform workflows */
      if (!initialFlow.isClassicWorkflow) {
        return {
          value: null
        };
      }
      return {
        value: getGoalFilters(initialFlow)
      };
    },
    useStaged: false
  });
  const enrollmentList = useSettingsModelState({
    flow,
    initialize: initialFlow => {
      /* initialize to null for platform workflows */
      return {
        value: getEnrollmentList(initialFlow.toHybridFlowInterface())
      };
    },
    useStaged: false
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UnenrollmentSettingsSection, {
      flow: flow,
      readOnly: true,
      suppressionFilters: suppressionFilters,
      classicEnrollmentSettings: classicEnrollmentSettings,
      suppressionLists: suppressionLists,
      goalFilters: goalFilters,
      enrollmentList: enrollmentList,
      onChange: () => {}
    }), /*#__PURE__*/_jsx(UIButton, {
      className: "m-top-3",
      use: "tertiary-light",
      size: "small",
      onClick: () => {
        history.push({
          pathname: `${getEnrollmentConfigRoute({
            flow
          })}/unenrollment`,
          search: history.location.search
        });
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.enrollmentStep.enrollment.editUnenrollment"
      })
    })]
  });
};
export default UnenrollmentReviewSection;